module.exports = __webpack_public_path__ + "static/media/dark-modulo-comercial.53e4bec4.svg";